import styled from 'styled-components';

import colors from '../../../../../../../../styles/colors';

const QuestionsContainer = styled.li`
  margin: 0 0 15px;
  font-size: 18px;
`;

const QuestionsContainerWrapper = styled.ol`
  width: 95%;
  padding-left: 30px;
  & > li::marker {
    font-size: 15px;
    color: ${colors.shades.gamma10};
  }
`;

const Question = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${colors.shades.gamma10};
  padding-bottom: 10px;
`;

const Answer = styled.p`
  font-size: 0.8em;
  margin: 0;
  white-space: pre-wrap;
  border-bottom: 1px solid ${colors.shades.secondary7};
  padding-bottom: 15px;
`;

export {
  QuestionsContainer,
  QuestionsContainerWrapper,
  Question,
  Answer,
};
